import * as angular from "angular";

const resolvingTypes = {
  unresolved: 'Unresolved',
  notResolved: 'Not Resolved', // location resolved by integration
  resolvedUsingReceivedCoordinates: 'Resolved Using Received Coordinates',
  autoResolvedFromManualHistory: 'Auto Resolved From Manual History',
  rooftop: 'Auto Geocoded Precise',
  rangeInterpolate: 'Auto Geocoded Interpolated',
  geometricCenter: 'Auto Geocoded Approximate Structure',
  approximate: 'Auto Geocoded Approximated General',
}


angular
.module('bringoz.admin.addresses')
.constant('addressResolver', {
  resolvingTypes: resolvingTypes,
});
